// extracted by mini-css-extract-plugin
module.exports = {"rating":"_93444fe79c--rating--MeqQN"};